import React, { useEffect, useContext, useState } from "react";
import DropDown from "../../components/_default/DropDown";
import { getClients, getDailyMeasurementProgress, getCLientById, getAllCoaches } from "../../services/firebase/firestore/getData";
import { updateCoach } from "../../services/firebase/firestore/updateData";
import "./Subs.scss";

function Sub({ coach }) {
    const [status, setStatus] = useState(coach.status ? coach.status : 'Trial');

    const DropDownOptions = ['Trial','Closed','Paid'];

    useEffect(() => {
        updateCoach({status: status}, coach.id, callback => {
            console.log(callback);
        })
    }, [status])

    return (
        <div className="c-exercise-list-item no-hover" style={{ padding: 10 }}>
          <div className="c-exercise-list-item-data">
            <div className="c-exercise-user-image" style={{ backgroundImage: `url('${coach.image}')` }}>
                {coach.image === "" && <p>{coach.first_name[0] + coach.last_name.match(/\b(\w)/g).join("")}</p>}
              </div>
            <div className="c-exercise-text">
              <h3>{coach.first_name} { coach.last_name }</h3>
              <p style={{fontWeight: 300}}>{ coach.email }</p>
            </div>
            {
              coach?.registrationDate&&
            
            <div className="c-exercise-text">
              
              <p style={{fontWeight: 300,paddingLeft:"100px"}}>{coach?.registrationDate?.toDate().getDate()}/{coach?.registrationDate?.toDate().getMonth() + 1}/{coach?.registrationDate?.toDate().getFullYear()}</p>
            </div>
            }
              
          </div>
          <div style={{ paddingRight: 20 }}>
          { !coach.admin ? (
              <div className="c-exercise-icons">
                <DropDown zindex={ 'auto' } options={DropDownOptions ? DropDownOptions : []} value={status} onChange={(e) => {setStatus(e)}} />
              </div>
            ) : <span><i>Admin </i></span>
            }
          </div>
        </div>
    )
}

export default Sub;